module.exports = __webpack_public_path__ + "img/DE00637.59debd15.png";